// extracted by mini-css-extract-plugin
module.exports = {"Container":"Page_Container__fNfZ8","LeftCol":"Page_LeftCol__yLu97"};